common.View.create('canvas.blocks.custom.portfolioSlider.Block', {
    onDOMLoad() {
        this.initSwiper();
    },

    initSwiper() {
        let swiperEl = this.element.find('.portfolioSwiper');

        if (swiperEl.data('swiper-enabled') === false) {
            return;
        }

        new Swiper('.portfolioSwiper', {
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 25,
                },
                480: {
                    slidesPerView: 1.5,
                    spaceBetween: 50,
                },
                768: {
                    slidesPerView: 2.25,
                    spaceBetween: 50,
                },
                1024: {
                    slidesPerView: 3.25,
                    spaceBetween: 75,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    },
});
